export const StyleConstants = {
  SCROLLBAR_WIDTH: 8,
  SIDE_BAR_WIDTH: {
    lg: 312,
    xxl: 336,
  },
};
